module.exports = "images/teamed_image_05.png";